import { Text } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import { type MRT_ColumnDef, type MRT_RowData } from "mantine-react-table-open";
import { MantineIconCell } from "../../../../../../mantine/mrt/components/cell/MantineIconCell";
import { MeterMeasurementType } from "../../../../../../types/api.types";
import { THEME_VARS } from "../../../../../../utils/constants";
import type { Meter } from "../../../../SiteSetupAssistant.types";
import { getMeterTableErrorText } from "../getMeterTableErrorText";

const MEASUREMENT_TYPE_CHOICES = [
  { value: MeterMeasurementType.Single, label: "Lastgang" },
  {
    value: MeterMeasurementType.ArbitraryCumulative,
    label: "Zählerstände (selbst abgelesen)"
  },
  { value: MeterMeasurementType.NoMeter, label: "Kein Zähler vorhanden" }
];

export function getMeterMeasurementTypeColumn<T extends MRT_RowData>(
  getCellError: (
    rowIndex: number,
    accessorKey: keyof Meter
  ) => Array<string> | null | undefined
): MRT_ColumnDef<T> {
  return {
    accessorKey: "measurement_type",
    header: "Wie wird gemessen?",
    editVariant: "select",
    Cell: ({ cell, row }) => {
      const displayText = MEASUREMENT_TYPE_CHOICES.find(
        (choice) => choice.value === cell.getValue()
      )?.label;
      const cellError = getCellError(row.index, "measurement_type");
      return (
        <div>
          {displayText}
          {cellError && (
            <MantineIconCell
              iconColor={THEME_VARS.error[6]}
              IconComponent={IconAlertTriangle}
              renderedCellValue={
                <Text c="error">{getMeterTableErrorText(cellError[0])}</Text>
              }
            />
          )}
        </div>
      );
    },
    mantineEditSelectProps: () => ({
      "aria-label": "Wie wird gemessen?",
      data: MEASUREMENT_TYPE_CHOICES
    })
  };
}
